import { Card, Col, Form, Row, Select } from "@pankod/refine-antd";
import { DefaultMaskedInput } from "components/extra/default-masked-input";
import { ShootBlockingOperation } from "enums";
import { FC } from "react";
import { shootBlockingOperationMap } from "utils/constants";
import { MyFormProps } from ".";

const BASIC_PAYLOAD = {
  engaged: false,
  quarantine: false,
  blocklist: false,
  response: false,
  reactivation: false,
};

interface IShootBlockingForm {
  phone: string;
  operation: ShootBlockingOperation;
}

export const ShootBlockingForm: FC<MyFormProps> = ({
  formProps: { onFinish, ...formProps },
}) => {
  const operationOptions = [
    ShootBlockingOperation.BLOCKLIST_MANUAL,
    ShootBlockingOperation.REACTIVATION_MANUAL,
  ];

  const handleFinish = (values: IShootBlockingForm) => {
    const cleanedPhone = values.phone.replace(/\D/g, "");

    const manualOperations: Record<string, string> = {
      [ShootBlockingOperation.BLOCKLIST_MANUAL]: "blocklist",
      [ShootBlockingOperation.REACTIVATION_MANUAL]: "reactivation",
    };

    const operationKey = manualOperations[values.operation] ?? values.operation;

    const payload = {
      ...BASIC_PAYLOAD,
      [operationKey]: true,
      user: {
        phone: cleanedPhone,
      },
    };

    onFinish?.(payload);
  };

  return (
    <Card>
      <Form
        {...formProps}
        onFinish={handleFinish}
        layout="vertical"
        style={{ padding: 16 }}
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Telefone"
              name="phone"
              rules={[
                { required: true, message: "Telefone é obrigatório", min: 19 },
              ]}
            >
              <DefaultMaskedInput
                mask="+55 (00) 00000-0000"
                className="input-custom ant-input"
                placeholder="+55 (00) 00000-0000"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              name="operation"
              label="Motivo"
              rules={[{ required: true, message: "Motivo é obrigatório" }]}
            >
              <Select placeholder="Selecione o motivo" allowClear>
                {operationOptions.map((item) => (
                  <Select.Option key={item} value={item}>
                    {shootBlockingOperationMap[item].label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
